import { Auth } from 'aws-amplify';
import settings from '../config/settings';

const oauth = {
  domain: settings.AWS_AMPLIFY_DOMAIN,
  cope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
  redirectSignIn: settings.AMPLIFY_CALLBACKS.REDIRECT_SIGN_IN,
  redirectSignOut: settings.AMPLIFY_CALLBACKS.REDIRECT_SIGN_OUT,
  responseType: 'code',
};

Auth.configure({
  oauth,
  region: settings.AWS_COGNITO.AUTH_REGION,
  identityPoolId: settings.AWS_COGNITO.AUTH_IDENTITY_POOL_ID,
  userPoolId: settings.AWS_COGNITO.AUTH_USER_POOL_ID,
  userPoolWebClientId: settings.AWS_COGNITO.AUTH_USER_POOL_WEB_CLIENT_ID,
});

export const signUp = async data => {
  try {
    await Auth.signUp({
      username: data.email,
      password: data.password,
      attributes: {
        name: data.name,
        email: data.email,
      },
    });
  } catch (error) {
    console.log('error signing up:', error);
    throw error;
  }
};

export const confirmSignUp = async (username, code) => {
  try {
    await Auth.confirmSignUp(username, code);
  } catch (error) {
    console.log('error confirming sign up:', error);
    throw error;
  }
};

export const signIn = async (email, password) => {
  try {
    const username = email;
    return await Auth.signIn(username, password);
  } catch (error) {
    console.log('error signing in', error);
    throw error;
  }
};

export const signOut = async () => {
  try {
    return await Auth.signOut();
  } catch (error) {
    console.log('error signing out', error);
    throw error;
  }
};

export const verifySession = async () => {
  try {
    return await Auth.currentSession();
  } catch (error) {
    console.log('error verifying in', error);
    throw error;
  }
};

export const forgotPassword = async username => {
  try {
    return await Auth.forgotPassword(username);
  } catch (error) {
    console.log('error forgot password in', error);
    throw error;
  }
};

export const forgotPasswordSubmit = async data => {
  try {
    return await Auth.forgotPasswordSubmit(data.email, data.code, data.password);
  } catch (error) {
    console.log('error confirming password:', error);
    throw error;
  }
};

export const resendSignUp = async username => {
  try {
    return await Auth.resendSignUp(username);
  } catch (error) {
    console.log('error resending code', error);
    throw error;
  }
};

export const currentUser = async () => {
  try {
    return await Auth.currentAuthenticatedUser();
  } catch (error) {
    console.log('error resending code', error);
    throw error;
  }
};

export const googleSignin = async () => {
  try {
    return await Auth.federatedSignIn({ provider: 'Google' });
  } catch (error) {
    console.log('error resending code', error);
    throw error;
  }
};
